import { FilledButton } from "@nykaa/payment-ui/src/Button";
import { BUTTON_TYPE } from "../../../constants";
import React from "react";
import { IRetryComponent } from "../@types";
import FailureDetails from "./FailureDetails";
import { CustomButtonLayout } from "../assets/style";

/**
 * component to return Bottomsheet details
 * when no fallback mode exist for the failed payment method
 */
export const RetryComponent = (props: IRetryComponent) => {
  const { theme, nonFallbackMessages, onRetryButtonClick, retryButtonText, totalSaved } = props;
  // Do not render Retry messages if nonFallbackMessages does not exist or nonFallbackMessages is empty
  if (!(nonFallbackMessages && Object.keys(nonFallbackMessages))) {
    return <></>;
  }
  return (
    <>
      <FailureDetails
        theme={theme}
        fallbackMessages={nonFallbackMessages}
        totalSaved={totalSaved}
      />
      <CustomButtonLayout>
        <FilledButton
          text={retryButtonText}
          onClick={onRetryButtonClick}
          buttonType={BUTTON_TYPE.LARGE}
          dataTestId={"payment_failure_retry_button"}
          theme={theme}
        />
      </CustomButtonLayout>
    </>
  );
};
